import Storage from '@/services/Storage'

const localStorage = new Storage(window.localStorage)

const state = {
  items: localStorage.getObject('cart') ? localStorage.getObject('cart') : []
}

const getters = {
  getCartItems (state) {
    return state.items
  },
  getCartTotal (state) {
    return state.items.reduce((accumulator, current) => {
      return accumulator + current.amount
    }, 0)
  },
  getCartIsFree (state) {
    return state.items.every((item) => {
      return item.type === 'FREE'
    })
  },
  getCartCount (state) {
    return state.items.length
  }
}

const mutations = {
  SET_CART_ITEM (state, item) {
    state.items.unshift(item)
    localStorage.setObject('cart', state.items)
  },
  DELETE_CART_ITEM (state, item) {
    state.items = state.items.filter((stateItem) => !(stateItem.id === item.id))
    localStorage.setObject('cart', state.items)
  },
  CLEAR_CART (state, item) {
    state.items = []
    localStorage.setObject('cart', state.items)
  }
}

const actions = {
  setCartItem ({ commit, state }, item) {
    const hasItem = state.items.some((stateItem) => stateItem.id === item.id)
    if (!hasItem) {
      commit('SET_CART_ITEM', item)
    }
  },
  deleteCartItem (context, item) {
    context.commit('DELETE_CART_ITEM', item)
  },
  clearCart (context) {
    context.commit('CLEAR_CART')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
